import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { Icon } from 'src/common/components/templateDetails/TemplateDetails.styled';
import { ENVIRONMENTVARIABLE } from 'src/constants/appConstants';

export const SearchResultsContainer = styled.div`
    width: 95%;
    margin: 0 auto;
    height: 100%;

    ${media.mediumDevice`
       width: 96%;
    `}
    ${media.mobileDevice`
        display: flex;
        flex-direction: column;
        position: relative;
        overflow-y: scroll;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch
        width: 95%;
    `};
`;

export const SearchHeader = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding-top: 9px;
    ${media.mediumDevice`
        padding-top: 9px;
    `}
    ${media.mobileDevice`
        display: flex;   
        align-items: center;
        padding: 15px 10px;
    `}
`;

export const DemiText = styled.div`
    color: #140f4b;
    font-size: 20px;
    font-family: AvenirNextWorld Demi;
    display: none;
    ${media.mobileDevice`
        justify-content: center;
        display: flex;
        width: ${({ mbWidth }) => (mbWidth ? mbWidth : '100%')};
        margin-right:19px;
    `}
`;

export const OrderCardsContainer = styled.div`
    margin: 0;
    display: flex;
    flex-direction: column;
    ${media.mobileDevice`
    //height: calc(100% - 8rem);
    height: auto;
    margin-left: -10px;
    margin-right: -10px;
    margin-top: -4px;
    `}
`;

export const BackButtonContainer = styled.div`
    display: inline-flex;
    margin: ${({ margin }) => (margin ? margin : '0 0 0 10px')};
    width: 100%;
    ${media.mobileDevice`
    width: auto;
    `}
`;

export const BackButtonIcon = styled.img`
    margin: ${({ margin }) => (margin ? margin : '0')};
    cursor: pointer;
    ${media.mobileDevice`
        margin:1;
    `}
`;

export const BackText = styled.span`
    // margin-left: 5px;
    color: #1010eb;
    font-family: AvenirNextWorld Regular;
    font-size: 16px;
    cursor: pointer;
    ${media.mobileDevice`
        display: ${({ mbDisplay }) => mbDisplay && mbDisplay};
    `}
`;

export const MessageContainer = styled.div`
    color: #140f4b;
    font-family: AvenirNextWorld Regular;
    font-size: 16px;
    margin-top: 0.5rem;

    ${media.mobileDevice`
        padding: ${({ mbPadding }) =>
            mbPadding ? mbPadding : '10px 15px 0 6px'};
        margin-top: 0px;
    `}
`;

export const TableContainer = styled.div`
    // margin-top: 3%;
    margin-top: 15px;
`;
export const BoldText = styled.span`
    color: #140f4b;
    font-family: AvenirNextWorld Demi;
    font-size: 16px;
`;

export const CloseIconContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    order: 4;
    width: 5%;
    align-items: center;
    ${media.mobileDevice`
        display: none;
    `}
`;

export const CloseIcon = styled(Icon)``;
export const PaginationContainerMobile = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px;
    width: 100%;
    ${media.mobileDevice`
        flex-direction:column;
        margin: 10px 0px 0px 0px;
        justify-content: space-between;
        // position: sticky;
        // bottom:0;
        padding-bottom:${({ padding }) =>
            ENVIRONMENTVARIABLE ? '0px' : padding ? padding : '1.125rem'} 
    `}
`;

export const SearchIconContainer = styled(CloseIconContainer)``;

export const SearchIcon = styled.img.attrs((props) => ({
    src: props.deskPath,
}))`
    width: 27px;
    height: 27px;
    display: block;
    cursor: pointer;
    ${media.mobileDevice`
    display: block;
    `}
`;
